import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Phone, MapPin, Mail, Clock, MessageCircle } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_12492ec0-1e26-4f4b-96d9-e0a655349093/artifacts/4uh3nwhf_image.png";
const WHATSAPP_NUM = "14164172525";

export function ContactPopup({ open, onOpenChange }) {
  const openWhatsApp = (msg) => {
    window.open(`https://wa.me/${WHATSAPP_NUM}?text=${encodeURIComponent(msg || 'Hi, I\'m interested in your inventory. Can you help me?')}`, '_blank');
  };

  const downloadVCard = () => {
    const vcard = `BEGIN:VCARD\nVERSION:3.0\nFN:Canadian Truck Sales\nORG:Canadian Truck Sales\nTEL;TYPE=WORK:(416) 417-2525\nTEL;TYPE=WORK:(844) 417-2525\nADR;TYPE=WORK:;;5939 Shawson Dr Suite #100;Mississauga;ON;L4W 3Y2;Canada\nEMAIL:info@canadiantrucksales.ca\nURL:https://canadiantrucksales.ca\nEND:VCARD`;
    const blob = new Blob([vcard], { type: 'text/vcard' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a'); a.href = url; a.download = 'Canadian_Truck_Sales.vcf'; a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-sm p-0 overflow-hidden rounded-xl" data-testid="contact-popup">
        <DialogTitle className="sr-only">Contact Canadian Truck Sales</DialogTitle>
        {/* Logo header — full width, prominent */}
        <div className="bg-white px-6 pt-8 pb-4 flex flex-col items-center" data-testid="contact-popup-header">
          <img src={LOGO_URL} alt="Canadian Truck Sales" className="h-20 w-auto mb-3" />
          <p className="text-[#0A0A0A] font-bold text-base tracking-tight">Canadian Truck Sales</p>
          <p className="text-zinc-400 text-xs">Premium Commercial Vehicles</p>
        </div>

        <div className="border-t border-gray-100" />

        {/* Contact info — bottom section */}
        <div className="px-5 py-4 space-y-3" data-testid="contact-popup-info">
          <a href="tel:+14164172525" className="flex items-center gap-3 text-sm text-zinc-700 hover:text-[#E31937] transition-colors py-1">
            <div className="w-8 h-8 bg-[#E31937]/10 rounded-full flex items-center justify-center flex-shrink-0">
              <Phone className="w-4 h-4 text-[#E31937]" />
            </div>
            <div>
              <p className="font-semibold">(416) 417-2525</p>
              <p className="text-[10px] text-zinc-400">Local</p>
            </div>
          </a>
          <a href="tel:+18444172525" className="flex items-center gap-3 text-sm text-zinc-700 hover:text-[#E31937] transition-colors py-1">
            <div className="w-8 h-8 bg-[#E31937]/10 rounded-full flex items-center justify-center flex-shrink-0">
              <Phone className="w-4 h-4 text-[#E31937]" />
            </div>
            <div>
              <p className="font-semibold">(844) 417-2525</p>
              <p className="text-[10px] text-zinc-400">Toll-free</p>
            </div>
          </a>
          <a href="https://maps.google.com/?q=5939+Shawson+Dr+Suite+100+Mississauga+ON+L4W+3Y2" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-sm text-zinc-700 hover:text-[#E31937] transition-colors py-1">
            <div className="w-8 h-8 bg-[#E31937]/10 rounded-full flex items-center justify-center flex-shrink-0">
              <MapPin className="w-4 h-4 text-[#E31937]" />
            </div>
            <div>
              <p className="font-semibold">5939 Shawson Dr Suite #100</p>
              <p className="text-[10px] text-zinc-400">Mississauga, ON L4W 3Y2</p>
            </div>
          </a>
          <a href="mailto:info@canadiantrucksales.ca" className="flex items-center gap-3 text-sm text-zinc-700 hover:text-[#E31937] transition-colors py-1">
            <div className="w-8 h-8 bg-[#E31937]/10 rounded-full flex items-center justify-center flex-shrink-0">
              <Mail className="w-4 h-4 text-[#E31937]" />
            </div>
            <span className="font-semibold">info@canadiantrucksales.ca</span>
          </a>
          <div className="flex items-center gap-3 text-sm text-zinc-500 py-1">
            <div className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center flex-shrink-0">
              <Clock className="w-4 h-4 text-zinc-400" />
            </div>
            <div className="text-xs">
              <p>Mon-Fri: 9AM-6PM | Sat: 10AM-5PM</p>
              <p>Sun: Closed</p>
            </div>
          </div>
        </div>

        {/* Action buttons */}
        <div className="border-t border-gray-100 px-5 py-3 flex gap-2">
          <Button size="sm" className="flex-1 bg-[#E31937] hover:bg-[#C4122C] text-white text-xs h-9" onClick={() => window.open('tel:+14164172525')} data-testid="popup-call-btn">
            <Phone className="w-3.5 h-3.5 mr-1.5" /> Call Now
          </Button>
          <Button size="sm" className="flex-1 bg-[#25D366] hover:bg-[#1fb855] text-white text-xs h-9" onClick={() => openWhatsApp()} data-testid="popup-whatsapp-btn">
            <MessageCircle className="w-3.5 h-3.5 mr-1.5" /> WhatsApp
          </Button>
          <Button size="sm" variant="outline" className="text-xs h-9 border-gray-200" onClick={downloadVCard} data-testid="popup-save-btn">
            Save
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
